import React from "react";
import { CardLayout } from "components/cardLayout";
import { CardSubItem } from "components/cardSubItem";
import { CardTitle } from "components/cardTitle";
import { Button } from "components/button";
import "./Booked.scss"
import { CardItem } from "components/cardItem";
import moment from "moment";
import { navigate } from "@reach/router";

export interface BookedProps {
    title?: string;
    description?: string;
    location?: string;
    startTime?: string | Date;
    endTime?: string | Date;
}

export interface BookedState {

}

class Booked extends React.Component<BookedProps, BookedState> {
    constructor(props: BookedProps) {
        super(props);
        this.state = {};
    }

    render() {
        var object = JSON.parse(localStorage.getItem("movewith") || '{}');
        var custDetails = JSON.parse(localStorage.getItem("customerDetails") || '{}');
        var estDetails = JSON.parse(localStorage.getItem("EstimatorDetails") || '{}');
        

        var moveDate = moment(estDetails.moveDate).format("MM/DD/YYYY");
        if (localStorage.getItem('notsure') == "1") {
            moveDate = "Not sure";
        }
        // if(moveDate.toLowerCase.toString().indexOf('invalid')>=0){
        //     moveDate="Not Sure"
        // }

        return (
            <CardLayout style={{ padding: "2em 1.5em 1em 1.5em" }}>
                <div className="customer-title">
                    {/* <h3>You Move was already Booked</h3> */}
                    <h3>Thank you for signing your estimate, your move is now booked! If you have any questions on your move please contact your estimator <strong>{custDetails.estimatorName}</strong> at <strong>{custDetails.estimatorPhone}</strong></h3>
                </div>
                
            </CardLayout>
        );
    }

}

export default Booked
